import { render, staticRenderFns } from "./CustomerCard.vue?vue&type=template&id=f97586bc&scoped=true&"
import script from "./CustomerCard.vue?vue&type=script&lang=js&"
export * from "./CustomerCard.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCard.vue?vue&type=style&index=0&id=f97586bc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f97586bc",
  null
  
)

export default component.exports